import React from "react";
import { Box, Chip } from "@mui/material";
import {
  ALL_BUSINESS_TYPES,
  ALL_COUNTRIES,
  type AdminScopeFilterValues,
} from "./AdminScopeFilters";
import { labelForAdminCountry } from "./adminMarketCountries";
import { formatBusinessTypeLabel } from "./adminEnumLabels";

interface Props {
  values: AdminScopeFilterValues;
  onClearCountry?: () => void;
  onClearBusinessType?: () => void;
  onClearAll?: () => void;
  extra?: React.ReactNode;
}

const AdminActiveFilterChips: React.FC<Props> = ({
  values,
  onClearCountry,
  onClearBusinessType,
  onClearAll,
  extra,
}) => {
  const hasScope =
    values.countryCode !== ALL_COUNTRIES ||
    values.businessType !== ALL_BUSINESS_TYPES;

  if (!hasScope && !extra) return null;

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
    >
      {values.countryCode !== ALL_COUNTRIES && (
        <Chip
          size="small"
          label={`Country: ${labelForAdminCountry(values.countryCode)}`}
          onDelete={onClearCountry}
        />
      )}
      {values.businessType !== ALL_BUSINESS_TYPES && (
        <Chip
          size="small"
          label={`Industry: ${formatBusinessTypeLabel(values.businessType)}`}
          onDelete={onClearBusinessType}
        />
      )}
      {extra}
      {hasScope && onClearAll && (
        <Chip
          size="small"
          variant="outlined"
          label="Clear filters"
          onClick={onClearAll}
        />
      )}
    </Box>
  );
};

export default AdminActiveFilterChips;
